// extracted by mini-css-extract-plugin
export default {"JobworksPage":"JobworksPage_JobworksPage__qTcJU"};